import { Table as MuiTable, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';

const Table = ({ data, variant }) => {
  function createData (id, surname, firstName, email, persons) {
    return { id, surname, firstName, email, persons };
  }

  const rows = (leads) => {
    return Object.values(leads).map((lead, i) => {
      return createData(lead.id, lead.surname, lead.firstName, lead.email, lead.persons);
    });
  };

  return <TableContainer>
    <MuiTable>
      <TableHead>
        <TableRow>
          <TableCell>Nom</TableCell>
          <TableCell>Prénom</TableCell>
          <TableCell>adresse email</TableCell>
          <TableCell>Nbr.</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows(data).map((row) => (
          <TableRow key={row?.id}>
            <TableCell>{row?.surname}</TableCell>
            <TableCell>{row?.firstName}</TableCell>
            <TableCell>{row?.email}</TableCell>
            <TableCell>{row?.persons}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </MuiTable>
  </TableContainer>;
};

export default Table;